import { TotalSumTypes } from './types';
import formatReportBalance from '../../../hoc/helpers/format-report-balance';

import cn from './reports.module.css';

const ReportTotalSum = ({ total, title, className }: TotalSumTypes) => (
  <div className={`${cn.totalSum} ${className}`}>
    <div className={`${cn.totalSumValue} ${cn.totalSumName}`}>
      <span>{title}</span>
    </div>
    <div className={cn.totalSumValue} />
    <div className={cn.totalSumValue}>
      <span>{formatReportBalance(total.debitIn)}</span>
    </div>
    <div className={cn.totalSumValue}>
      <span>{formatReportBalance(total.creditIn)}</span>
    </div>
    <div className={cn.totalSumValue}>
      <span>{formatReportBalance(total.debitTo)}</span>
    </div>
    <div className={cn.totalSumValue}>
      <span>{formatReportBalance(total.creditTo)}</span>
    </div>
    <div className={cn.totalSumValue}>
      <span>{formatReportBalance(total.debitOut)}</span>
    </div>
    <div className={cn.totalSumValue}>
      <span>{formatReportBalance(total.creditOut)}</span>
    </div>
  </div>
);

export default ReportTotalSum;
